export interface Locale {
    /** The [BCP47](https://www.ietf.org/rfc/bcp/bcp47.txt) language code for the locale. */
    locale: string;
    /** The writing direction for the locale. */
    direction: "ltr" | "rtl";
}

export function useDefaultLocale(): Locale {
    return {
        locale: "en-US",
        direction: "ltr",
    };
}
